const LAYOUT_SETTINGS_KEY = 'talent_admin_layout_settings'

const DEFAULT_LAYOUT_SETTINGS = {
  themeColor: '#409EFF',
  topbarStyle: 'light',
  sidebarTheme: 'dark',
  sidebarMode: 'classic',
  showLogo: true,
  logoImageUrl: '',
  fixedHeader: true,
  showTagsView: true,
  dynamicTitle: true
}

export function getLayoutSettings() {
  const raw = localStorage.getItem(LAYOUT_SETTINGS_KEY)
  if (!raw) {
    return { ...DEFAULT_LAYOUT_SETTINGS }
  }
  try {
    return {
      ...DEFAULT_LAYOUT_SETTINGS,
      ...JSON.parse(raw)
    }
  } catch (e) {
    return { ...DEFAULT_LAYOUT_SETTINGS }
  }
}

export function setLayoutSettings(settings) {
  localStorage.setItem(LAYOUT_SETTINGS_KEY, JSON.stringify(settings || {}))
}

export function getDefaultLayoutSettings() {
  return { ...DEFAULT_LAYOUT_SETTINGS }
}
